import React, { useEffect, useRef, useState } from 'react';

const HomePage = () => {
    const burger = useRef(null);
    const menuMobile = useRef(null);
    const myNav = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        if(isOpen) {
            burger.current.classList.remove('open');
            menuMobile.current.classList.remove('open');
            setIsOpen(false);
        }else{
            burger.current.classList.add('open');
            menuMobile.current.classList.add('open');
            setIsOpen(true);
        }
    }

    const closeBurger = () => {
        burger.current.classList.remove('open');
        menuMobile.current.classList.remove('open');
        setIsOpen(false);
    }

    useEffect(() => {
        let scrolling = 0

        window.addEventListener('scroll', ()=>{
            scrolling= document.documentElement.scrollTop || window.scrollY || window.pageYOffset || document.body.scrollTop
            if(scrolling > 20)
            {
                burger.current.classList.add('scroll')
                myNav.current.classList.add('scroll')
            }else{
                burger.current.classList.remove('scroll')
                myNav.current.classList.remove('scroll')
            }
        })
    },[])

    return(
        <>
            <div id="menu-mobile" ref={menuMobile}>
                <nav>
                    <ul>
                        <li><a href="#presentation" onClick={closeBurger}>Présentation</a></li>
                        <li><a href="#programme" onClick={closeBurger}>Programme</a></li>
                        <li><a href="#debouche" onClick={closeBurger}>Débouchés</a></li>
                        <li><a href="#contact" onClick={closeBurger}>Contact</a></li>
                    </ul>
                </nav>
            </div>
            <div className="slide" id="home">
                <div className="wrapper">
                    <header>
                        <div id="logo">
                            <img src="/images/LogoEAE2.svg" alt="Logo EPSE"/>
                        </div>
                        <nav ref={myNav}>
                            <ul>
                                <li><a href="#presentation">Présentation</a></li>
                                <li><a href="#programme">Programme</a></li>
                                <li><a href="#debouche">Débouchés</a></li>
                                <li><a href="#contact">Contact</a></li>
                            </ul>
                        </nav>
                        <div id="burger" ref={burger} onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </header>
                    <div id="jumbotron">
                        <h3><span>Enseignement</span> pour adultes d'Enghien</h3>
                        <h1>Vidéaste</h1>
                        <h4>Apprends à raconter en images</h4>
                        <a href="https://www.epse.be/inscription" target='_blank' className="btn">Inscris-toi</a>
                    </div>
                    <div id="promise">
                        <div className="stat">
                            <div className="title">Début</div>
                            <div className="value">Septembre 2025</div>
                        </div>
                        <div className="stat">
                            <div className="title">Durée</div>
                            <div className="value">2 ans</div>
                        </div>
                        <div className="stat">
                            <div className="title">Prérequis</div>
                            <div className="value">Aucun</div>
                        </div>
                    </div>
                </div>
                <div className="social-media">
                    <div className="title">Suis-nous ici !</div>
                    <div className="links">
                        <img src="/images/arrow.svg" alt="Flèche"/>
                        <a className='social-link' href="https://www.linkedin.com/school/epse/" target="_blank">
                            <img src="/images/socials/linked.svg" alt="EPSE LinkedIn" />
                        </a>
                        <a className='social-link' href="https://www.facebook.com/EPSEMarcq/" target="_blank">
                            <img src="/images/socials/facebook.svg" alt="EPSE Facebook" />
                        </a>
                        <a className='social-link' href="https://www.youtube.com/channel/UC33Fs4BdaHlEb5GfDoZzSsA?view_as=subscriber" target="_blank">
                            <img src="/images/socials/youtube.svg" alt="EPSE YouTube" />
                        </a>
                        <a className='social-link' href="https://www.tiktok.com/@e.p.s.e" target="_blank">
                            <img src="/images/socials/tiktok.svg" alt="EPSE TikTok" />
                        </a>
                        <a className='social-link' href="https://www.instagram.com/e.p.s.e/" target="_blank">
                            <img src="/images/socials/insta.svg" alt="EPSE Instagram" />
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomePage;